const initState = [];
const EncounterNotesDisplaySettingsReducer = (state = initState,action) => {
    if(['EncounterNotesDisplaySettings'].includes(action.type)){
        console.log("actionEncounterNotesDisplaySettings" , action)
        // return {...state , [action.payload.NoteType] :action.payload};
        return action.payload
    }
    else {
        return state;
    }
}

export default EncounterNotesDisplaySettingsReducer